<template>
  <div>
    <support-toolbar />
    <div class="card  mx-md-5 mt-3 mb-3 bg-form">
      <card-header
        :title="$t('support.managementTitle')"
        :iconName="'person-fill'"
      />
      <b-card-body>
        <b-alert variant="success" v-model="popSuccessAlert" dismissible> {{ this.successMessage }} </b-alert>
        <b-alert v-for="error in errors" :key="error.message" v-model="popAlert"  variant="danger" dismissible>
          {{ error.message }}
        </b-alert>
        <!-- Update Commission Member Form -->
        <template v-if="this.showUpdateCommMember">
          <div class="card w-50 mx-auto">
            <b-card-header class="esep-blue-bg text-light">
              <h6  class="float-left font-weight-bold">{{ $t('support.updateCommMember')}}</h6>
            </b-card-header>
            <b-card-body>
              <h6 class="col-md-12"> {{$t('support.confirmUpdate', { name: this.memberToUpdate.member.surName + " " + this.memberToUpdate.member.firstName })}}  </h6>
              <div class="row">
                <b-form-group
                    id="input-group-newTitles"
                    :label="$t('support.newTitles') + ' *'"
                    label-for="newTitles-datepicker"
                    label-align="left"
                    class="col-md-6"
                >
                  <b-select class="" v-model="memberToUpdate.title" :options="titles"  size="sm">
                  </b-select>
                </b-form-group>
                <b-form-group
                    id="input-group-startDate"
                    :label="$t('support.startDate') + ' *'"
                    label-for="startDate-datepicker"
                    label-align="left"
                    class="col-md-6"
                >
                  <b-form-datepicker
                      id="startDate-datepicker"
                      placeholder=""
                      v-model="startDate"
                      value-as-date
                      locale="en-GB"
                      class="col-lg-8 col-sm-12"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                      
                  >
                  </b-form-datepicker>
                </b-form-group>
              </div>
              <div class="row">
                <b-form-group
                  id="input-group-update-member"
                  :label="$t('support.updateComments') + ' *'"
                  label-for="input-comment"
                  label-align="left"
                  class="col-md-6"
                >
                  <b-form-input
                    id="input-comment"
                    v-model="updateComments"
                    type="text"
                  ></b-form-input>
                </b-form-group> 
              </div>
              <div class="float-left mt-2">
                <b-button @click="submitUpdateMember" variant="primary" class="mr-1 esep-blue-bg" :disabled="this.updateComments.length == 0 || this.startDate == null">{{
                  $t("common.submit")
                }}</b-button>
                <b-button @click="showUpdateMember(null)" variant="danger" >{{
                  $t("common.cancel")
                }}</b-button>
              </div>
            </b-card-body>
          </div>
        </template>
        <!-- Delete Commission Member Form -->
        <template v-if="this.showDeleteCommMember">
          <div class="card w-50 mx-auto">
            <b-card-header class="esep-blue-bg text-light">
              <h6  class="float-left font-weight-bold">{{ $t('support.deleteCommMember')}}</h6>
            </b-card-header>
            <b-card-body>
              <h6 class="col-md-12"> {{$t('support.confirmDelete', { name: this.memberToDelete.member.surName + " " + this.memberToDelete.member.firstName })}}  </h6>
              <div class="row">
                <b-form-group
                    id="input-group-endDate"
                    :label="$t('support.endDate') + ' *'"
                    label-for="endDate-datepicker"
                    label-align="left"
                    class="col-md-6"
                >
                  <b-form-datepicker
                      id="endDate-datepicker"
                      placeholder=""
                      v-model="endDate"
                      value-as-date
                      locale="en-GB"
                      class="col-lg-8 col-sm-12"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                      
                  >
                  </b-form-datepicker>
                </b-form-group>
                <b-form-group
                  id="input-group-delete-member"
                  :label="$t('support.deleteComments') + ' *'"
                  label-for="input-comment"
                  label-align="left"
                  class="col-md-6"
                >
                  <b-form-input
                    id="input-comment"
                    v-model="deleteComments"
                    type="text"
                  ></b-form-input>
                </b-form-group> 
              </div>
              <div class="float-left mt-2">
                <b-button @click="submitDeleteMember" variant="primary" class="mr-1 esep-blue-bg" :disabled="this.deleteComments.length == 0 || this.endDate == null">{{
                  $t("common.submit")
                }}</b-button>
                <b-button @click="showDeleteFn(null)" variant="danger" >{{
                  $t("common.cancel")
                }}</b-button>
              </div>
            </b-card-body>
          </div>
        </template>
        <!-- Withdraw Support Commission Form -->
        <template v-if="this.showWithdrawSupport">
          <div class="card w-50 mx-auto">
            <b-card-header class="esep-blue-bg text-light">
              <h6  class="float-left font-weight-bold">{{ $t('support.withdrawSupport')}}</h6>
            </b-card-header>
            <b-card-body>
              <div class="row">
                <b-form-group
                  id="input-group-withdraw-commission"
                  :label="$t('support.withdrawComments') + ' *'"
                  label-for="input-comment"
                  label-align="left"
                  class="col-md-9"
                >
                  <b-form-input
                    id="input-comment"
                    v-model="withdrawComments"
                    type="text"
                  ></b-form-input>
                </b-form-group> 
              </div>
              <div class="float-left mt-2">
                <b-button @click="submitWithdrawSupport" variant="primary" class="mr-1 esep-blue-bg" :disabled="this.withdrawComments.length == 0 || this.endDate == null">{{
                  $t("common.submit")
                }}</b-button>
                <b-button @click="showWithdrawSupportFn(false)" variant="danger" >{{
                  $t("common.cancel")
                }}</b-button>
              </div>
            </b-card-body>
          </div>
        </template>
        <!-- Change Due Date of Support Commission Form -->
        <template v-if="this.showChangeDueDate">
          <div class="card w-50 mx-auto">
            <b-card-header class="esep-blue-bg text-light">
              <h6  class="float-left font-weight-bold">{{ $t('support.changeDueDate')}}</h6>
            </b-card-header>
            <b-card-body>
              <div class="row">
                <b-form-group
                    id="input-due-date"
                    :label="$t('support.dueDate')"
                    label-for="due-date"
                    label-align="left"
                    label-cols-sm="5"
                    content-cols-sm="4"
                    class="col-md col-sm-4">
                  <b-form-datepicker
                      id="due-date"
                      v-model="currentCommission.dueDate"
                      :placeholder="$t('members-table.chooseADate')"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                      locale="en-GB"
                      value-as-date
                  ></b-form-datepicker>
                </b-form-group>
              </div>
              <div class="float-left mt-2">
                <b-button @click="submitChangeDueDate" variant="primary" class="mr-1 esep-blue-bg" :disabled="this.endDate == null">{{
                    $t("common.submit")
                  }}</b-button>
                <b-button @click="submitChangeDueDateFn(false)" variant="danger" >{{
                    $t("common.cancel")
                  }}</b-button>
              </div>
            </b-card-body>
          </div>
        </template>
        <template v-if="this.supportMembersList != null && this.usersAccessibleUnits != null">
          <support-members-table :supportMembersList="this.supportMembersList" :pageName="this.pageName"
                                 :usersAccessibleUnits="this.usersAccessibleUnits"
                                 :selectedUnitId="this.selectedUnitId" :expirableCommissions="expirableCommissions"
                                 :currentCommission="this.currentCommission"
            @unit-changed="unitChanged" v-on:error:api.capture="handleError" @show-delete="showDeleteFn"
                                 @show-update-due-date="submitChangeDueDateFn" @update-member="showUpdateMember" @show-withdraw-support="showWithdrawSupportFn"/>
        </template>
      </b-card-body>
    </div>
  </div>
</template>

<script>
import { roles, routes } from "esep/src/services/routing.service";
import { hasRole} from "esep/src/services/utils";
import cardHeader from '../../components/common/cardHeader.vue';
import SupportMembersTable from '../../components/support/supportMembersTable.vue';
import SupportToolbar from '../../components/support/supportToolbar.vue';
import { handleApiError } from '../../services/error.service';
import memberService from '../../services/member.service';

const now = new Date();
const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

export default {
  components: { cardHeader, SupportToolbar, SupportMembersTable },
  data() {
    return {
      popAlert: false,
      errors: [],
      popSuccessAlert: false,
      successMessage: null,
      currentCommission: null,
      supportMembersList: null,
      expirableCommissions: null,
      usersAccessibleUnits: null,
      usersModableUnits: null,
      usersAdminableUnits: null,
      selectedUnitId: null,
      pageName: 'supportActive',
      showDeleteCommMember: false,
      deleteComments: '',
      showWithdrawSupport: false,
      showChangeDueDate: false,
      withdrawComments: '',
      memberToDelete: null,
      showUpdateCommMember: false,
      updateComments: '',
      memberToUpdate: null,
      startDate: today,
      endDate: today,
      titles: [
        {value: "PRESIDENT", text: this.$t('supportEnums.PRESIDENT')},
        {value:"VICE_PRESIDENT", text: this.$t('supportEnums.VICE_PRESIDENT')},
        {value:"SECRETARY", text: this.$t('supportEnums.SECRETARY')},
        {value:"CLERK", text: this.$t('supportEnums.CLERK')},
        {value:"EQUIPMENT_RESP", text: this.$t('supportEnums.EQUIPMENT_RESP')},
        {value:"MEMBER", text: this.$t('supportEnums.MEMBER')}
      ],
    }
  },
  mounted() {
    memberService.getUserInfo(this.username).then(
      (response) => {
        this.userInfo = response.data;
        if (!hasRole(this.userInfo,roles.members.support.active)){
          location.replace(routes.nothing);
        }
        this.$store.state.userInfo = this.userInfo;
        this.fetchAccessibleUnits();
        
      },
      (error) => {
        let errorMessage = handleApiError(error);
        this.handleError(errorMessage);
      }
    );
  },
  methods: {
    handleError(errors) {
      errors.forEach(error => {
        console.error(error);
        error.message = this.$t(`error.${error.code}`);
      })
      this.errors = errors;
      this.popAlert = errors.length>0;
    },
    fetchAccessibleUnits(){
      memberService.getAccessibleUnits(this.username).then(
          (response) => {
            this.usersAdminableUnits = response.data.ADMIN_UNIT;
            this.$store.state.usersAdminableUnits = this.usersAdminableUnits;
            this.usersModableUnits = response.data.MOD_UNIT;
            this.$store.state.usersModableUnits = this.usersModableUnits;
            this.usersAccessibleUnits = response.data.VIEW_UNIT;
            this.$store.state.usersAccessibleUnits = this.usersAccessibleUnits;

            if (this.usersAccessibleUnits.length <= 1 || this.$store.state.globalUnitId){
              this.selectedUnitId = this.usersAccessibleUnits[0].id;
            }else {
              this.selectedUnitId = parseInt(this.$store.state.globalUnitId);
            }

            this.getAvailableCommissionsToExpire();
            this.getSupportMembers(this.selectedUnitId);
          },
          (error) => {
            let errorMessage = handleApiError(error);
            this.handleError(errorMessage);
          }
      );
    },
    getSupportMembers(unitId) {
      let status = 'ACTIVE'
      memberService.getSupportCommission(unitId, status).then(
        (response) => {
          this.$log.debug(response.data)
          if(response.data.length > 0) {
            this.currentCommission = response.data[0];
            this.currentCommission.members.forEach(member => {
              member.dueDate = this.currentCommission.dueDate;
              member.numberOfContinuous = null;
              this.getSupportMemberHistory(member);
            });
          } else {
            this.supportMembersList = [];
          }
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.handleError(errorMessage);
        }
      )
    },
    getAvailableCommissionsToExpire() {
      memberService.getAvailableCommissionsToExpire(this.selectedUnitId).then(
        (response) => {
          if(response.data != null) {
            this.expirableCommissions = response.data;
          } else { 
            this.expirableCommissions = [];
          }
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.handleError(errorMessage);
        }
      );
    },
    refreshList(unitId) {
      this.supportMembersList = null;
      this.getSupportMembers(unitId);
      this.getAvailableCommissionsToExpire();
    },
    unitChanged(unit) {
      if( unit != null) {
        this.selectedUnitId= unit.id;
        this.currentCommission = null;
        this.refreshList(unit.id);
      } else {
        this.selectedUnitId= null;
        this.currentCommission = null;
        this.supportMembersList = [];
      } 
    },
    showDeleteFn(member) {
      this.$log.debug(member)
      if (member == null) {
        this.showDeleteCommMember = false;
        this.memberToDelete = null;
        this.popAlert = false;
      } else {
        this.memberToDelete = member;
        this.showDeleteCommMember = true;
        this.deleteComments = '';
        window.scrollTo(0,0);
      }
    },
    submitDeleteMember() {
      this.memberToDelete.exitDate = this.endDate;
      memberService.changeSupportMemberTitle(this.memberToDelete).then(
        ( response ) => {
          this.$log.debug(response);
          this.showDeleteCommMember = false;
          this.successMessage = this.$t('support.successfullDeleted');
          this.popSuccessAlert = true;
          this.refreshList(this.selectedUnitId);
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.handleError(errorMessage);
        }
      )
    },
    showUpdateMember(member) {
      if (member == null) {
        this.showUpdateCommMember = false;
        this.memberToUpdate = null;
        this.popAlert = false;
      } else {
        this.memberToUpdate = member;
        this.showUpdateCommMember = true;
        this.updateComments = '';
        window.scrollTo(0,0);
      }
      
    },
    submitUpdateMember() {
      this.$log.debug(this.memberToUpdate)
      memberService.changeSupportMemberTitle(this.memberToUpdate, this.updateComments).then(
        ( response ) => {
          this.$log.debug(response);
          this.successMessage = this.$t('support.successfullUpdated');
          this.popSuccessAlert = true;
          this.refreshList(this.selectedUnitId);
          this.showUpdateMember(null);
        },
        (error) => {
          this.$log.debug(error)
          this.handleError(handleApiError(error));
          this.refreshList(this.selectedUnitId);
          this.showUpdateMember(null);
        }
      )
    },
    getSupportMemberHistory(member) {
      memberService.getSupportMemberHistory(member.member.id, member.title).then(
        (response) => {
          this.$log.debug(response.data);
          member.numberOfContinuous = response.data.length;
          this.$log.debug(member)
          if(this.supportMembersList != null ) {
            if(!member.exitDate){
              this.supportMembersList.push(member);
            }
            
          } else {
            this.supportMembersList = [member]
          }
          
        },
        (error) => {
          this.errorMessage =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
          this.$log.debug(this.errorMessage);
        }
      )
    },
    showWithdrawSupportFn(show) {
      this.showWithdrawSupport = show;
    },
    submitWithdrawSupport() {
      memberService.expireCommission(this.currentCommission.id , this.withdrawComments).then(
          (response) => {
            this.$log.debug(response);
            this.showWithdrawSupport = false;
            this.withdrawComments = '';
            this.successMessage = this.$t('support.successfullUpdated');
            this.popSuccessAlert = true;
            this.refreshList(this.selectedUnitId);
          },
          (error) => {
            this.showWithdrawSupport = false;
            this.withdrawComments = '';
            let errorMessage = handleApiError(error);
            this.handleError(errorMessage);
          }
      )
    },
    submitChangeDueDateFn(show) {
      this.showChangeDueDate = show;
    },
    submitChangeDueDate() {
      memberService.updateCommission(this.selectedUnitId , this.currentCommission).then(
        (response) => {
          this.currentCommission = response.data;
          this.showChangeDueDate = false;
          this.successMessage = this.$t('support.successfullUpdated');
          this.popSuccessAlert = true;
          this.refreshList(this.selectedUnitId);
        },
        (error) => {
          this.showChangeDueDate = false;
          let errorMessage = handleApiError(error);
          this.handleError(errorMessage);
        }
      )
    }
  }
}
</script>